import { h } from 'preact';
import { useState, useRef, useEffect } from 'preact/hooks';
import { Transition } from '@headlessui/react';
import useDebounce from 'utils/debounce';
import HeaderNavItem from './header-nav-item';
import HeaderNavOverlay from './header-nav-overlay';
import MenuItem from './menu-item';

const HeaderNav = ({
  links,
  itemClass,
  listClass,
  background,
  container,
  withMegaMenu = false,
  ...props
}) => {
  if (!links.length) {
    return null;
  }
  const [overlayActive, setOverlayActive] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const debouncedItem = useDebounce(activeItem, 200);

  const megaMenu = useRef(null);
  const hoverHandle = (item) => {
    if (withMegaMenu) {
      setActiveItem(item);
      container?.current.classList.add('mega-menu');
      setOverlayActive(true);
    }
  };
  const blurHandle = () => {
    if (withMegaMenu) {
      container?.current.classList.remove('mega-menu');
      megaMenu.current.parentElement.style.height = 0;
      setOverlayActive(false);
      setActiveItem(null);
    }
  };

  useEffect(() => {
    if (activeItem) {
      const wrapper = megaMenu.current.parentElement;
      wrapper.style.height = `${megaMenu.current.offsetHeight}px`;
    }
  }, [debouncedItem]);

  return (
    <nav {...props} onMouseLeave={blurHandle}>
      <HeaderNavOverlay isActive={overlayActive} />
      <ul className={`${listClass}`}>
        {links.map((link, index) => (
          <HeaderNavItem
            link={link}
            container={container}
            withMegaMenu={withMegaMenu}
            onOverlayUpdate={setOverlayActive}
            className={itemClass}
            key={index}
            onMouseEnter={() => hoverHandle(link.id)}
          />
        ))}
      </ul>
      {!!withMegaMenu && (
        <div
          className="h-0 overflow-hidden ease-out duration-200 absolute top-full w-full left-0"
          style={{ background }}
        >
          <div ref={megaMenu}>
            {links.map((link) => (
              <Transition
                key={link.id}
                show={activeItem === link.id}
                enter="transition-opacity ease-linear duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity ease-linear duration-0"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                {(!!link.navs.length || !!link.stories.length) && (
                  <MenuItem
                    {...link}
                    background={background}
                    className="mega-menu"
                  />
                )}
              </Transition>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default HeaderNav;
